<template>
  <footer class="page_footer">
    <section class="footer_container">
      <div>
        <slot name="text"></slot>
      </div>
      <div class="buttons">
        <slot name="button"></slot>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
  name: "PageFooter"
};
</script>

<style>
</style>